
  var Global_eSig_LSA = [];
  
  function MetaeSigLSA( CommandKey,
                        CommandValue1,
                        CommandValue2,
                        CommandValue3,
                        CommandValue4)
  {
    var postcode=0;
    
    // Create form data
    var formData = new FormData();
    
    formData.append("Field_CommandKey",CommandKey);
    formData.append("Field_CommandValue1",CommandValue1);
    formData.append("Field_CommandValue2",CommandValue2);
    formData.append("Field_CommandValue3",CommandValue3);
    formData.append("Field_CommandValue4",CommandValue4);
    
    document.getElementById('rrdo-lsa-esig-date-last').style.display='none';
    
    var xhr = new XMLHttpRequest();

    xhr.onreadystatechange =
      function(e)
      {
        if (xhr.readyState == 4)
        {
          if ( xhr.status == 200 )
          {

            switch( xhr.responseText[0] )
            {
              case '!':
                // invalid session
                
                console.log( xhr.responseText );
                
                // window.location="/login";
              break;

              default:
                 postcode=1;
                
                 console.log( xhr.responseText );

                 switch ( CommandKey )
                 {
                   case "M": // Modify
                      document.getElementById('esig-agree-button').style.display='none';
                      document.getElementById('rrdo-lsa-esig-date-last-menu-bar').innerHTML = 'Last Signed ' + CommandValue2 ;
                   break;
                     
                   case "L": // Load
                     
                     Global_eSig_LSA = [];
                     
                     var LSA_RawArray  = xhr.responseText.split("\n");
                     
                     var tnthisLSA_Count = LSA_RawArray.length;
                     
                     var thisDatarec ;
 

                     for ( mi=0; mi<tnthisLSA_Count; mi++ )
                     {
                       tszrecobjstr = LSA_RawArray[mi]; 
                       
                       // console.log(tszrecobjstr);
                       
                       if ( tszrecobjstr[0] == '{' )
                       {
                         // Decode to Rate Array
                         var thisDatarec = eval( "("+tszrecobjstr+")" ); 
                       
                         t_lsa = new Object();
             
                         t_lsa.esig_date = thisDatarec.esig_date ;
                         t_lsa.esig_name = thisDatarec.esig_name ;
                        
                         Global_eSig_LSA.push(t_lsa);
                         
                         
                         document.getElementById('rrdo-lsa-esig-date-last').style.display='block';  
                         document.getElementById('Field_esig_name').value = t_lsa.esig_name ;
                         
                         document.getElementById('rrdo-lsa-esig-date-last').innerHTML = '' ;
                         document.getElementById('rrdo-lsa-esig-date-last-menu-bar').innerHTML = 'Please Open and Agree' ;
                                              
                         if ( document.getElementById('Field_esig_name').value.length > 0 )
                         {   
                           document.getElementById('rrdo-lsa-esig-date-last').innerHTML = 'Last Signed ' + t_lsa.esig_date ;
                           document.getElementById('rrdo-lsa-esig-date-last-menu-bar').innerHTML = 'Last Signed ' + t_lsa.esig_date ;
                         }  
                         
                        
                                                
                       }

                     }

                   break;
                 }

              break;
            }

          }
          else
          {
            // fail
          }
          
          console.log(Global_eSig_LSA);
        }
      };

    xhr.open("POST", "https://portal.ruggedradios.com/meta-esig-lsa/" , true);

    xhr.send(formData);

    return postcode;    
  }
  
  
  
  